module.exports = __webpack_public_path__ + "static/media/pinterest.17021b21.svg";